import React, { useState } from 'react';
import Header from 'components/ui/Header';
import ContactQuickAccess from 'components/ui/ContactQuickAccess';
import Breadcrumb from 'components/ui/Breadcrumb';
import Icon from 'components/AppIcon';

import ContactInfo from './components/ContactInfo';
import QuoteRequestForm from './components/QuoteRequestForm';

const ContactQuoteRequest = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [referenceNumber, setReferenceNumber] = useState('');

  const handleFormSubmit = (formData) => {
    // Generate reference number
    const refNumber = `BAC-${Date.now().toString().slice(-6)}`;
    setReferenceNumber(refNumber);
    setFormSubmitted(true);
    
    // Scroll to top to show confirmation
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const resetForm = () => {
    setFormSubmitted(false);
    setReferenceNumber('');
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-16">
        {/* Hero Section */}
        <section className="bg-primary text-white py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-heading font-bold mb-6">
                Contacto y Solicitud de Cotización
              </h1>
              <p className="text-xl text-blue-100 max-w-3xl mx-auto">
                Estamos aquí para ayudarte con todos tus necesidades de limpieza de piscinas. 
                Contáctanos para una cotización gratuita y personalizada.
              </p>
            </div>
          </div>
        </section>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <Breadcrumb />

          {/* Success Message */}
          {formSubmitted && (
            <div className="bg-success/10 border border-success/20 rounded-lg p-6 mb-8">
              <div className="flex items-start space-x-3">
                <Icon name="CheckCircle" size={24} className="text-success mt-1" />
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-success mb-2">
                    ¡Solicitud Enviada Exitosamente!
                  </h3>
                  <p className="text-text-secondary mb-3">
                    Hemos recibido tu solicitud de cotización. Nuestro equipo se pondrá en contacto contigo 
                    dentro de las próximas 24 horas durante días laborales.
                  </p>
                  <div className="bg-white rounded-lg p-4 border border-success/20">
                    <p className="text-sm text-text-secondary mb-1">Número de referencia:</p>
                    <p className="font-mono text-lg font-semibold text-primary">{referenceNumber}</p>
                    <p className="text-xs text-text-secondary mt-2">
                      Guarda este número para futuras consultas sobre tu solicitud.
                    </p>
                  </div>
                  <button
                    onClick={resetForm}
                    className="mt-4 text-sm text-primary hover:text-primary/80 font-medium"
                  >
                    Enviar otra solicitud →
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Main Content */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div className="order-2 lg:order-1">
              <ContactInfo />
            </div>

            {/* Quote Request Form */}
            <div className="order-1 lg:order-2">
              {!formSubmitted && (
                <QuoteRequestForm onSubmit={handleFormSubmit} />
              )}
            </div>
          </div>

          {/* Additional Information */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Clock" size={32} className="text-primary" />
              </div>
              <h3 className="text-lg font-semibold text-text-primary mb-2">
                Respuesta Rápida
              </h3>
              <p className="text-text-secondary">
                Respondemos todas las consultas dentro de 24 horas durante días laborales.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Calculator" size={32} className="text-accent" />
              </div>
              <h3 className="text-lg font-semibold text-text-primary mb-2">
                Cotización Gratuita
              </h3>
              <p className="text-text-secondary">
                Todas nuestras cotizaciones son completamente gratuitas y sin compromiso.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Shield" size={32} className="text-success" />
              </div>
              <h3 className="text-lg font-semibold text-text-primary mb-2">
                Servicio Garantizado
              </h3>
              <p className="text-text-secondary">
                Todos nuestros servicios están respaldados por nuestra garantía de satisfacción.
              </p>
            </div>
          </div>
        </div>
      </main>

      <ContactQuickAccess />
    </div>
  );
};

export default ContactQuoteRequest;